/**
 * @file Frontend module — App.tsx.
 */

import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import "./theme/theme.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CementBoxPlotChart } from "./components";

const App = () => (
  <AuthProvider>
    {/* TEMP: Preview CementBoxPlotChart - Remove after testing */}
    {/* <div style={{ padding: "20px", background: "#fff" }}>
      <CementBoxPlotChart />
    </div> */}
    <AppRoutes />
    <ToastContainer
      position="top-center"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  </AuthProvider>
);

/** React component — App. */
export default App;
